export default __webpack_public_path__ + "static/media/property_880.b66500df.png";